// Alamat halaman Portal Member.
//
// Di domain member (fasttrack-member.com) Portal Member dipasang di AKAR domain:
// /masuk, /kelas, /akun … (klien 26 Okt 2026: "biar lebih clean"). Di tempat
// lain — localhost:3003 saat dev — tetap di bawah /m, karena satu frontend CRA
// juga melayani admin & Portal Karyawan di akar. Nginx domain member
// mengalihkan /m/* lama (link WA, PWA yang sudah terpasang, push lama) ke
// alamat tanpa /m. Semua link member WAJIB lewat mr(), jangan tulis '/m/…'.
//
// Nama domain juga tertulis di public/service-worker.js (tidak ikut dibundel).
export const DOMAIN_MEMBER = /^(www\.)?fasttrack-member\./i.test(window.location.hostname);

export const BASIS = DOMAIN_MEMBER ? '' : '/m';

// mr('/kelas') → '/kelas' (domain member) atau '/m/kelas' (dev). Menerima juga
// URL lama berawalan /m — url push dari server masih '/m/akun' dan berlaku di dua tempat.
export function mr(p = '/') {
  const bersih = String(p).replace(/^\/m(?=\/|$)/, '') || '/';
  if (!BASIS) return bersih;
  return bersih === '/' ? BASIS : BASIS + bersih;
}
